import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.1;
  }
  10% {
    opacity: 0.3;
  }
  50% {
    transform: translateY(-100px) rotate(180deg);
    opacity: 0.6;
  }
  90% {
    opacity: 0.3;
  }
  100% {
    transform: translateY(-200px) rotate(360deg);
    opacity: 0;
  }
`;

const floatSlow = keyframes`
  0% {
    transform: translateY(0px) translateX(0px) rotate(0deg);
    opacity: 0.1;
  }
  25% {
    opacity: 0.4;
  }
  50% {
    transform: translateY(-50px) translateX(20px) rotate(180deg);
    opacity: 0.7;
  }
  75% {
    opacity: 0.4;
  }
  100% {
    transform: translateY(-100px) translateX(-20px) rotate(360deg);
    opacity: 0;
  }
`;

const floatFast = keyframes`
  0% {
    transform: translateY(0px) translateX(0px) rotate(0deg);
    opacity: 0.2;
  }
  20% {
    opacity: 0.5;
  }
  50% {
    transform: translateY(-150px) translateX(30px) rotate(270deg);
    opacity: 0.8;
  }
  80% {
    opacity: 0.5;
  }
  100% {
    transform: translateY(-300px) translateX(-30px) rotate(360deg);
    opacity: 0;
  }
`;

export const ParticleContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;

  .particle {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    
    &:nth-child(odd) {
      background: rgba(99, 102, 241, 0.3);
      animation: ${float} 15s linear infinite;
    }
    
    &:nth-child(even) {
      background: rgba(16, 185, 129, 0.3);
      animation: ${floatSlow} 25s linear infinite;
    }
    
    &:nth-child(3n) {
      background: rgba(245, 158, 11, 0.3);
      animation: ${floatFast} 20s linear infinite;
    }
    
    &:nth-child(4n) {
      background: rgba(139, 92, 246, 0.3);
      animation: ${float} 18s linear infinite;
    }
    
    &:nth-child(5n) {
      background: rgba(236, 72, 153, 0.3);
      animation: ${floatSlow} 22s linear infinite;
    }
  }
`;
